export default "__VITE_ASSET__kmdYf2dR__"